import { ChangeEvent, FC } from 'react';
import styles from './SliderWithTicks.module.scss';

interface SliderWithTicksProps {
  value: number | string | undefined;
  min: number | undefined;
  max: number | undefined;
  step?: number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  ariaLabel?: string;
  marks: number[];
}

export const SliderWithTicks: FC<SliderWithTicksProps> = ({
  value,
  min,
  max,
  step = 1,
  onChange,
  disabled,
  ariaLabel,
  marks,
}) => (
  <div className={styles.sliderContainer}>
    <input
      type="range"
      value={value}
      min={min}
      max={max}
      step={step}
      onChange={onChange}
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid="loan-term-slider"
    />
    <div className={styles.ticksOverlay}>
      {marks.map((mark, index) => {
        const pos = marks.length > 1 ? (index / (marks.length - 1)) * 100 : 0;
        return (
          <span
            key={mark}
            className={styles.tick}
            style={{ left: `${pos}%` }}
            data-testid={`loan-term-mark-${index}`}
          />
        );
      })}
    </div>
  </div>
);
